/**
 * @file JobBodyExtraInfoSlot.tsx
 *
 * @fileoverview This component renders aditional things to the job detail body. This can be used to add extra fields
 * or any other information relevant to the job information.
 */
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { Job } from '~/jobiqo/types/types';

interface JobBodyExtraInfoSlotProps {
  /**
   * The job entity.
   */
  job: Slottable<Job>;
}

export default function JobBodyExtraInfoSlot({
  job,
}: JobBodyExtraInfoSlotProps) {
  return null;
}
export { JobBodyExtraInfoSlot };
